import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from 'react-router-dom';


import { auth, logout, getData, updateDataByUserId } from "../../configs/firebase";
import { onAuthStateChanged } from "firebase/auth";

import { IMAGES } from "../../constants/index"
import RHEMAS from "../../constants/rhema";

import './MyRhemaPage.css';


function MyRhemaPage(){
    let navigate = useNavigate();

    let { id } = useParams();

    const [user, setUser] = useState(null);
    const [data,setData] = useState(0)
    const [opacity, setOpacity] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false); 
    const [dayIndex,setDayIndex] = useState(0)
    const [rhema, setRhema] = useState({});
    const [index, setIndex] = useState(0)


    // 🔹 로그인 상태 감지
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            if(currentUser) setUser(currentUser);
            else handlelogout()
        });
        return () => unsubscribe();
    }, []);

    // 🔹 첫 시작 시 페이드 인 적용
    useEffect(() => {
        if(user){
            getUserData();
        }
    }, [user]);

    useEffect(() => {
        if(data){
            checkRhema();
        }
    }, [data]);

    useEffect(() => {
        if(rhema){
            setTimeout(() => {
                setOpacity(1);
            }, 1000); // 0.5초 후 페이드 인
        }
    }, [rhema]);

    // useEffect(()=>{
    //     if(index) {
    //         getRhema();
    //     }
    // },[index])
    

    const getUserData = async () => {
        const data = await getData(user.uid)
        setData(data[0])
        setDayIndex(Object.keys(data[0]?.checkList || {}).length-1);
    }
    const checkRhema = () => {
        // getRhema()
        if(id&&data.rhema&&data.rhema[id]) {
            setRhema(data.rhema[id])
        }
    }
    const myFaithPage = async () => {
        setOpacity(0);
        setTimeout(() => {
            handleNavigation('/myFaith')
        }, 2000);
    }



    const handleNavigation = (address) => {
        navigate(address);
    }
    const handlelogout = async() => {
        const result = await logout()
        navigate('/login');
    }

      
    return (
        <div
            className="wrap"
            style={{
                backgroundImage: `url(${IMAGES.BACKGROUMND})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div className="rhemaWrap" style={{ opacity, transition: "opacity 1s ease-in-out" }} onClick={myFaithPage}>
                <div className="contentsTitle">
                    {/* <span>믿음의 여정</span> */}
                </div>
                <div className="contents">
                    {rhema&&
                    <>
                    <pre className="rhemaText">{rhema?.rhema}</pre>
                    <p className="addressText">{rhema?.address&&`[${rhema?.address}]`}</p>
                    {/* <span style={{color:'#fff'}}>{index}</span> */}
                    </>
                    }
                </div>    
                <div className="contentsButton">
                    {/* <span onClick={myFaithPage}>믿음의 여정 살펴보기</span> */}
                </div>       
            </div>
        </div>
    );
  }
  export default MyRhemaPage;